import "./pages.css";
import Footer from "../Home/footer";
import Header from "../Home/header";
const Callus = () => {
  return (
    <>
      <Header />
      <div className="blg">
        <div className="headblogs">
          <div className="titlehead">
            <h2 className="h2"> FAQ</h2>
          </div>
        </div>
        <div className="aboutus">
          <p className="paraaboutus">
            Here are some terms that could be included in a platform's terms of
            service for selling digital products: Acceptance of Terms: By using
            our platform, you agree to be bound by these terms of service.
            Account Registration: To sell products on our platform, you must
            create an account and provide accurate and complete information.
            Product Listing and Sales: You are responsible for creating accurate
            product listings and ensuring that your products are delivered to
            buyers in a timely manner. We reserve the right to remove any
            products that violate our policies. Fees and Payment: We may charge
            fees for the use of our platform and for processing payments. You
            agree to pay all fees in a timely manner. Intellectual Property: You
            represent and warrant that you have the right to sell any digital
            products you offer on our platform and that your products do not
            infringe on the intellectual property rights of any third party.
            Prohibited Conduct: You may not use our platform to engage in any
            illegal, fraudulent, or abusive conduct, or to harass or harm other
            users. Termination: We may terminate your account and remove your
            products from our platform at any time, for any reason. Disclaimer
            of Warranties: We make no warranties or representations about the
            quality, safety, or legality of the products sold on our platform.
            Limitation of Liability: Our liability for any damages arising from
            your use of our platform is limited to the fees paid by you to us in
            the twelve months preceding the claim. Governing Law: These terms of
            service shall be governed by and construed in accordance with the
            laws of the jurisdiction in which we are located.
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Callus;
